import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { MaintenanceService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Maintenance } from '../../models'

const log = new Logger('MaintenanceDetailResolver')
@Injectable({ providedIn: 'root' })
export class MaintenanceDetailResolver
  implements Resolve<Observable<Maintenance>> {
  constructor(private resService: MaintenanceService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let mid = route.params['mid']
    
    return this.resService.getDetail(mid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/admin/maintenance']))
    )
  }
}
